import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d6ceb9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "yearlyModalCard" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "header-left" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "비과세 적용 전후 비교표 (1년치)", -1))
const _hoisted_5 = {
  key: 0,
  class: "help-section"
}
const _hoisted_6 = { class: "help-header" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "help-title" }, "이 표는 뭔가요?", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "help-content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "help-block" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "help-subtitle" }, "한 줄 요약"),
    /*#__PURE__*/_createElementVNode("p", { class: "help-highlight" }, [
      /*#__PURE__*/_createTextVNode(" \"생산직 비과세\"를 적용하면 기관이 내는 4대보험료와 퇴직금이 줄어듭니다."),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 이 표는 "),
      /*#__PURE__*/_createElementVNode("strong", null, "적용 전"),
      /*#__PURE__*/_createTextVNode("과 "),
      /*#__PURE__*/_createElementVNode("strong", null, "적용 후"),
      /*#__PURE__*/_createTextVNode("를 비교해서 "),
      /*#__PURE__*/_createElementVNode("strong", null, "얼마나 절감되는지"),
      /*#__PURE__*/_createTextVNode(" 보여줍니다. ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "help-block" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "help-subtitle" }, "개선전 vs 개선후가 뭐예요?"),
    /*#__PURE__*/_createElementVNode("div", { class: "help-comparison" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "help-compare-box before" }, [
        /*#__PURE__*/_createElementVNode("strong", null, "개선전"),
        /*#__PURE__*/_createElementVNode("p", null, [
          /*#__PURE__*/_createTextVNode("기존 비과세만 적용"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("(식대, 차량유지비 등)")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "help-arrow" }, "→"),
      /*#__PURE__*/_createElementVNode("div", { class: "help-compare-box after" }, [
        /*#__PURE__*/_createElementVNode("strong", null, "개선후"),
        /*#__PURE__*/_createElementVNode("p", null, [
          /*#__PURE__*/_createTextVNode("생산직 비과세 추가 적용"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("(연장근무, 야간근무 등)")
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "help-block" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "help-subtitle" }, "각 항목 설명"),
    /*#__PURE__*/_createElementVNode("table", { class: "help-table" }, [
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", { class: "help-term" }, "비과세"),
        /*#__PURE__*/_createElementVNode("td", null, "세금을 안 내는 급여. 비과세가 많으면 → 과세소득이 줄어듦 → 4대보험료 감소")
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", { class: "help-term" }, "기관부담 4대보험"),
        /*#__PURE__*/_createElementVNode("td", null, "기관이 내는 국민연금, 건강보험, 고용보험 등의 합계")
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", { class: "help-term" }, "퇴직금"),
        /*#__PURE__*/_createElementVNode("td", null, "퇴직금 산정 기초 = (총급여 - 식대) ÷ 12")
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", { class: "help-term" }, "차액"),
        /*#__PURE__*/_createElementVNode("td", null, [
          /*#__PURE__*/_createTextVNode("개선후 - 개선전. "),
          /*#__PURE__*/_createElementVNode("span", { class: "text-green" }, "음수(-)면 절감"),
          /*#__PURE__*/_createTextVNode(", "),
          /*#__PURE__*/_createElementVNode("span", { class: "text-red" }, "양수(+)면 증가")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", { class: "help-term" }, "월 절감액"),
        /*#__PURE__*/_createElementVNode("td", null, [
          /*#__PURE__*/_createTextVNode("기관부담 차액 + 퇴직금 차액. "),
          /*#__PURE__*/_createElementVNode("span", { class: "text-green" }, "음수(-)가 좋은 것!")
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "help-block" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "help-subtitle" }, "계산 예시"),
    /*#__PURE__*/_createElementVNode("div", { class: "help-example" }, [
      /*#__PURE__*/_createElementVNode("p", null, [
        /*#__PURE__*/_createTextVNode("직원 A씨의 총급여: "),
        /*#__PURE__*/_createElementVNode("strong", null, "3,000,000원")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "help-calc-row" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "calc-label" }, "개선전 비과세:"),
        /*#__PURE__*/_createElementVNode("span", null, [
          /*#__PURE__*/_createTextVNode("식대 20만 + 차량 20만 = "),
          /*#__PURE__*/_createElementVNode("strong", null, "40만원")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "help-calc-row" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "calc-label" }, "개선전 과세소득:"),
        /*#__PURE__*/_createElementVNode("span", null, [
          /*#__PURE__*/_createTextVNode("300만 - 40만 = "),
          /*#__PURE__*/_createElementVNode("strong", null, "260만원")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "help-calc-row mt" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "calc-label" }, "개선후 비과세:"),
        /*#__PURE__*/_createElementVNode("span", null, [
          /*#__PURE__*/_createTextVNode("40만 + 연장야간 24만 = "),
          /*#__PURE__*/_createElementVNode("strong", null, "64만원")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "help-calc-row" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "calc-label" }, "개선후 과세소득:"),
        /*#__PURE__*/_createElementVNode("span", null, [
          /*#__PURE__*/_createTextVNode("300만 - 64만 = "),
          /*#__PURE__*/_createElementVNode("strong", null, "236만원")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "help-calc-row result" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "calc-label" }, "결과:"),
        /*#__PURE__*/_createElementVNode("span", null, "과세소득 24만원 감소 → 4대보험료 약 2~3만원 절감")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "help-note" }, " * 녹색 숫자 = 절감 (좋은 것) / 빨간색 숫자 = 증가 (안 좋은 것) ")
], -1))
const _hoisted_9 = { class: "info-section" }
const _hoisted_10 = { class: "info-row" }
const _hoisted_11 = { class: "info-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "조회 연도", -1))
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "info-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "데이터 현황", -1))
const _hoisted_16 = { class: "info-value" }
const _hoisted_17 = { class: "data-badge ledger" }
const _hoisted_18 = { class: "data-badge excel" }
const _hoisted_19 = { class: "data-badge none" }
const _hoisted_20 = { class: "action-section" }
const _hoisted_21 = {
  key: 1,
  class: "modal-content"
}
const _hoisted_22 = { class: "loading-state" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "데이터를 불러오는 중...", -1))
const _hoisted_24 = {
  key: 2,
  class: "modal-content"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "unit-label" }, "단위: 원", -1))
const _hoisted_26 = { class: "monthly-table-wrapper" }
const _hoisted_27 = { class: "monthly-table" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "sticky-col" }, "월"),
    /*#__PURE__*/_createElementVNode("th", null, "데이터 출처"),
    /*#__PURE__*/_createElementVNode("th", null, "대상 인원"),
    /*#__PURE__*/_createElementVNode("th", null, "총급여"),
    /*#__PURE__*/_createElementVNode("th", { class: "before-header" }, "개선전 비과세"),
    /*#__PURE__*/_createElementVNode("th", { class: "before-header" }, "개선전 기관부담"),
    /*#__PURE__*/_createElementVNode("th", { class: "before-header" }, "개선전 퇴직금"),
    /*#__PURE__*/_createElementVNode("th", { class: "after-header" }, "개선후 비과세"),
    /*#__PURE__*/_createElementVNode("th", { class: "after-header" }, "개선후 기관부담"),
    /*#__PURE__*/_createElementVNode("th", { class: "after-header" }, "개선후 퇴직금"),
    /*#__PURE__*/_createElementVNode("th", { class: "diff-header" }, "기관부담 차액"),
    /*#__PURE__*/_createElementVNode("th", { class: "diff-header" }, "퇴직금 차액"),
    /*#__PURE__*/_createElementVNode("th", { class: "saving-header" }, "월 절감액")
  ])
], -1))
const _hoisted_29 = { class: "sticky-col" }
const _hoisted_30 = { class: "text-center" }
const _hoisted_31 = {
  key: 0,
  class: "source-badge ledger"
}
const _hoisted_32 = {
  key: 1,
  class: "source-badge excel"
}
const _hoisted_33 = {
  key: 2,
  class: "source-badge none"
}
const _hoisted_34 = { class: "text-center" }
const _hoisted_35 = { class: "text-right" }
const _hoisted_36 = { class: "before-cell text-right" }
const _hoisted_37 = { class: "before-cell text-right" }
const _hoisted_38 = { class: "before-cell text-right" }
const _hoisted_39 = { class: "after-cell text-right" }
const _hoisted_40 = { class: "after-cell text-right" }
const _hoisted_41 = { class: "after-cell text-right" }
const _hoisted_42 = { class: "total-row" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "sticky-col font-bold" }, "연간 합계", -1))
const _hoisted_44 = { class: "text-center font-bold" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-center font-bold" }, "-", -1))
const _hoisted_46 = { class: "text-right font-bold" }
const _hoisted_47 = { class: "before-cell text-right font-bold" }
const _hoisted_48 = { class: "before-cell text-right font-bold" }
const _hoisted_49 = { class: "before-cell text-right font-bold" }
const _hoisted_50 = { class: "after-cell text-right font-bold" }
const _hoisted_51 = { class: "after-cell text-right font-bold" }
const _hoisted_52 = { class: "after-cell text-right font-bold" }
const _hoisted_53 = { class: "summary-section" }
const _hoisted_54 = { class: "summary-cards" }
const _hoisted_55 = { class: "summary-card before-card" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "개선전 (생산직비과세 미적용)", -1))
const _hoisted_57 = { class: "summary-row" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "연간 총급여", -1))
const _hoisted_59 = { class: "value" }
const _hoisted_60 = { class: "summary-row" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "연간 비과세", -1))
const _hoisted_62 = { class: "value" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_64 = { class: "summary-row" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "연간 기관부담 4대보험", -1))
const _hoisted_66 = { class: "value" }
const _hoisted_67 = { class: "summary-row" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "연간 퇴직금", -1))
const _hoisted_69 = { class: "value" }
const _hoisted_70 = { class: "summary-card after-card" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "개선후 (생산직비과세 적용)", -1))
const _hoisted_72 = { class: "summary-row" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "연간 총급여", -1))
const _hoisted_74 = { class: "value" }
const _hoisted_75 = { class: "summary-row" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "연간 비과세", -1))
const _hoisted_77 = { class: "value" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_79 = { class: "summary-row" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "연간 기관부담 4대보험", -1))
const _hoisted_81 = { class: "value" }
const _hoisted_82 = { class: "summary-row" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "연간 퇴직금", -1))
const _hoisted_84 = { class: "value" }
const _hoisted_85 = { class: "summary-card diff-card" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "연간 기관 비용 절감 효과", -1))
const _hoisted_87 = { class: "summary-row highlight-row" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "데이터 보유 기간", -1))
const _hoisted_89 = { class: "value" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_91 = { class: "summary-row" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "연간 기관부담 차액", -1))
const _hoisted_93 = { class: "summary-row" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "연간 퇴직금 차액", -1))
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_96 = { class: "summary-row total" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "연간 총 절감액", -1))
const _hoisted_98 = { class: "summary-row info" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "월 평균 절감액", -1))
const _hoisted_100 = { class: "monthly-chart-section" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "월별 절감액 추이", -1))
const _hoisted_102 = { class: "chart-container" }
const _hoisted_103 = { class: "chart-label" }
const _hoisted_104 = {
  key: 0,
  class: "chart-value"
}
const _hoisted_105 = {
  key: 3,
  class: "modal-content empty-state"
}
const _hoisted_106 = { class: "modal-footer" }

import { ref, reactive, computed } from "vue";
import { useStore } from "vuex";
import axios from "axios";

interface MonthlyData {
  month: string;
  hasData: boolean;
  dataSource: string | null;
  employeeCount: number;
  totalPay: string;
  before: { nonTax: string; companyIns: string; retirement: string };
  after: { nonTax: string; companyIns: string; retirement: string };
  diff: { nonTax: string; companyIns: string; retirement: string };
  saving: string;
  savingRaw: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'WageBeforeAfterYearly',
  setup(__props, { expose: __expose }) {

const store = useStore();
const dialog = ref(false);
const loading = ref(false);
const activeTab = ref("monthly");
const selectedYear = ref("");
const isGeneratingPdf = ref(false);
const showHelp = ref(false);
const monthlySummary = ref<MonthlyData[]>([]);
const yearlyRawData = ref<any[]>([]);

const availableYears = computed(() => {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let y = currentYear; y >= currentYear - 5; y--) {
    years.push(String(y));
  }
  return years;
});

const dataSourceCount = computed(() => {
  let ledger = 0;
  let excel = 0;
  let none = 0;
  
  for (const month of monthlySummary.value) {
    if (month.dataSource === 'ledger') ledger++;
    else if (month.dataSource === 'excel') excel++;
    else none++;
  }
  
  return { ledger, excel, none };
});

const hasAnyData = computed(() => {
  return dataSourceCount.value.ledger > 0 || dataSourceCount.value.excel > 0;
});

const yearlyTotals = reactive({
  totalPay: "0",
  before: { nonTax: "0", companyIns: "0", retirement: "0" },
  after: { nonTax: "0", companyIns: "0", retirement: "0" },
  diff: { nonTax: "0", companyIns: "0", retirement: "0" },
  saving: "0",
  avgSaving: "0"
});

const nc = (value: any): number => {
  if (value == null) return 0;
  return parseFloat(String(value).replace(/,/g, "")) || 0;
};

const ac = (number: number): string => {
  if (number === 0) return "0";
  return Math.round(number).toLocaleString();
};

const formatMonth = (ym: string): string => {
  if (!ym) return "";
  const parts = ym.split("-");
  if (parts.length === 2) {
    return `${parseInt(parts[1], 10)}월`;
  }
  return ym;
};

const getDiffClass = (value: string | undefined, isReverse = false): string => {
  if (!value) return "";
  const num = nc(value);
  if (isReverse) {
    if (num < 0) return "positive-diff";
    if (num > 0) return "negative-diff";
  } else {
    if (num > 0) return "positive-diff";
    if (num < 0) return "negative-diff";
  }
  return "";
};

const getBarHeight = (saving: number): number => {
  if (!saving) return 0;
  const absSaving = Math.abs(saving);
  const maxSaving = Math.max(...monthlySummary.value.map(m => Math.abs(m.savingRaw || 0)));
  if (maxSaving === 0) return 0;
  return Math.min(100, (absSaving / maxSaving) * 100);
};

const openDialog = async () => {
  dialog.value = true;
  activeTab.value = "monthly";
  selectedYear.value = store.state.AdminYYMM?.split('-')[0] || String(new Date().getFullYear());
  await fetchYearlyData();
};

const closeDialog = () => {
  dialog.value = false;
  showHelp.value = false;
};

const fetchYearlyData = async () => {
  loading.value = true;
  monthlySummary.value = [];
  yearlyRawData.value = [];
  
  try {
    const code = store.state.AdminSisulCode;
    const bizGubun = store.state.AdminBizGubun;
    
    const response = await axios.get(`/api/getYearlyComparisonData/${code}/${selectedYear.value}/${bizGubun}`);
    
    if (response.data.success) {
      yearlyRawData.value = response.data.data;
      const tax = response.data.tax;
      
      calculateYearlyComparison(response.data.data, tax);
    }
  } catch (error) {
    console.error("연간 데이터 조회 실패:", error);
    store.commit("showSnackbar", { text: "연간 데이터 조회 중 오류가 발생했습니다.", color: "error" });
  } finally {
    loading.value = false;
  }
};

const calculateYearlyComparison = (yearData: any[], tax: any) => {
  const results: MonthlyData[] = [];
  
  let sumTotalPay = 0;
  let sumBefore = { nonTax: 0, companyIns: 0, retirement: 0 };
  let sumAfter = { nonTax: 0, companyIns: 0, retirement: 0 };
  
  for (const monthItem of yearData) {
    if (!monthItem.hasData || !monthItem.data) {
      results.push({
        month: monthItem.month,
        hasData: false,
        dataSource: null,
        employeeCount: 0,
        totalPay: "-",
        before: { nonTax: "-", companyIns: "-", retirement: "-" },
        after: { nonTax: "-", companyIns: "-", retirement: "-" },
        diff: { nonTax: "-", companyIns: "-", retirement: "-" },
        saving: "-",
        savingRaw: 0
      });
      continue;
    }
    
    let monthTotalPay = 0;
    let monthBefore = { nonTax: 0, companyIns: 0, retirement: 0 };
    let monthAfter = { nonTax: 0, companyIns: 0, retirement: 0 };
    let employeeCount = 0;
    
    if (monthItem.dataSource === 'ledger') {
      const { wageData, basicData } = monthItem.data;
      employeeCount = wageData.length;
      
      for (const wage of wageData) {
        const basic = basicData.find((b: any) => b.empNum === wage.empNum);
        const total = nc(wage.total);
        monthTotalPay += total;
        
        const afterTaxable = nc(wage.taxable);
        const afterNonTax = total - afterTaxable;
        monthAfter.nonTax += afterNonTax;
        
        const afterCompanyIns = nc(wage.c_yeon) + nc(wage.c_gun) + nc(wage.c_jang) + 
                               nc(wage.c_go) + nc(wage.c_sil) + nc(wage.c_san);
        monthAfter.companyIns += afterCompanyIns;
        monthAfter.retirement += nc(wage.c_out);
        
        if (basic) {
          const beforeLunch = nc(basic.eaLunchPay);
          const beforeNonTax = nc(basic.eaDangPay) + beforeLunch + nc(basic.eaCarPay) + nc(basic.eaChildcarePay);
          const roundedBeforeNonTax = Math.floor(beforeNonTax / 10) * 10;
          monthBefore.nonTax += roundedBeforeNonTax;
          
          const beforeTaxable = Math.floor((total - roundedBeforeNonTax) / 10) * 10;
          
          const before_c_gun = nc(wage.c_gun) === 0 ? 0 : 
            Math.max(nc(wage.c_gun), Math.floor((beforeTaxable * (tax.tr_gun || 0.03545)) / 10) * 10);
          const before_c_jang = nc(wage.c_jang) === 0 ? 0 :
            Math.floor((before_c_gun * (tax.tr_jang || 0.1295)) / 10) * 10;
          const before_c_go = nc(wage.c_go) === 0 ? 0 :
            Math.max(nc(wage.c_go), Math.floor((beforeTaxable * (tax.tr_go || 0.009)) / 10) * 10);
          const before_c_sil = nc(wage.c_sil) === 0 ? 0 :
            Math.max(nc(wage.c_sil), Math.floor((beforeTaxable * (tax.tr_sil || 0.0055)) / 10) * 10);
          
          monthBefore.companyIns += nc(wage.c_yeon) + before_c_gun + before_c_jang + before_c_go + before_c_sil + nc(wage.c_san);
          monthBefore.retirement += nc(wage.c_out) === 0 ? 0 : Math.floor(((total - beforeLunch) / 12) / 10) * 10;
        }
      }
    } else if (monthItem.dataSource === 'excel') {
      const { excelData, calcData } = monthItem.data;
      employeeCount = calcData.length;
      
      for (const calc of calcData) {
        const excel = excelData.find((e: any) => e.empName === calc.empName);
        const total = nc(calc.total);
        monthTotalPay += total;
        
        const afterTaxable = nc(calc.taxable);
        const afterNonTax = total - afterTaxable;
        monthAfter.nonTax += afterNonTax;
        
        const afterCompanyIns = nc(calc.c_yeon) + nc(calc.c_gun) + nc(calc.c_jang) + 
                               nc(calc.c_go) + nc(calc.c_sil) + nc(calc.c_san);
        monthAfter.companyIns += afterCompanyIns;
        monthAfter.retirement += nc(calc.c_out);
        
        if (excel) {
          const beforeLunch = nc(excel.lunch);
          const beforeNonTax = nc(excel.dang) + beforeLunch + nc(excel.car) + nc(excel.childcare);
          const roundedBeforeNonTax = Math.floor(beforeNonTax / 10) * 10;
          monthBefore.nonTax += roundedBeforeNonTax;
          
          const beforeTaxable = Math.floor((total - roundedBeforeNonTax) / 10) * 10;
          
          let before_c_gun = 0, before_c_jang = 0, before_c_go = 0, before_c_sil = 0;
          if (afterTaxable > 0) {
            before_c_gun = nc(calc.c_gun) === 0 ? 0 :
              Math.floor((beforeTaxable * (nc(calc.c_gun) / afterTaxable)) / 10) * 10;
            before_c_jang = (nc(calc.c_jang) === 0 || nc(calc.c_gun) === 0) ? 0 :
              Math.floor((before_c_gun * (nc(calc.c_jang) / nc(calc.c_gun))) / 10) * 10;
            before_c_go = nc(calc.c_go) === 0 ? 0 :
              Math.floor((beforeTaxable * (nc(calc.c_go) / afterTaxable)) / 10) * 10;
            before_c_sil = nc(calc.c_sil) === 0 ? 0 :
              Math.floor((beforeTaxable * (nc(calc.c_sil) / afterTaxable)) / 10) * 10;
          }
          monthBefore.companyIns += nc(calc.c_yeon) + before_c_gun + before_c_jang + before_c_go + before_c_sil + nc(calc.c_san);
          monthBefore.retirement += nc(calc.c_out) === 0 ? 0 : Math.floor(((total - beforeLunch) / 12) / 10) * 10;
        }
      }
    }
    
    const diffCompanyIns = monthAfter.companyIns - monthBefore.companyIns;
    const diffRetirement = monthAfter.retirement - monthBefore.retirement;
    const saving = diffCompanyIns + diffRetirement;
    
    sumTotalPay += monthTotalPay;
    sumBefore.nonTax += monthBefore.nonTax;
    sumBefore.companyIns += monthBefore.companyIns;
    sumBefore.retirement += monthBefore.retirement;
    sumAfter.nonTax += monthAfter.nonTax;
    sumAfter.companyIns += monthAfter.companyIns;
    sumAfter.retirement += monthAfter.retirement;
    
    results.push({
      month: monthItem.month,
      hasData: true,
      dataSource: monthItem.dataSource,
      employeeCount: employeeCount,
      totalPay: ac(monthTotalPay),
      before: {
        nonTax: ac(monthBefore.nonTax),
        companyIns: ac(monthBefore.companyIns),
        retirement: ac(monthBefore.retirement)
      },
      after: {
        nonTax: ac(monthAfter.nonTax),
        companyIns: ac(monthAfter.companyIns),
        retirement: ac(monthAfter.retirement)
      },
      diff: {
        nonTax: ac(monthAfter.nonTax - monthBefore.nonTax),
        companyIns: ac(diffCompanyIns),
        retirement: ac(diffRetirement)
      },
      saving: ac(saving),
      savingRaw: saving
    });
  }
  
  monthlySummary.value = results;
  
  const diffNonTax = sumAfter.nonTax - sumBefore.nonTax;
  const diffCompanyIns = sumAfter.companyIns - sumBefore.companyIns;
  const diffRetirement = sumAfter.retirement - sumBefore.retirement;
  const totalSaving = diffCompanyIns + diffRetirement;
  const monthCount = dataSourceCount.value.ledger + dataSourceCount.value.excel;
  
  yearlyTotals.totalPay = ac(sumTotalPay);
  yearlyTotals.before.nonTax = ac(sumBefore.nonTax);
  yearlyTotals.before.companyIns = ac(sumBefore.companyIns);
  yearlyTotals.before.retirement = ac(sumBefore.retirement);
  yearlyTotals.after.nonTax = ac(sumAfter.nonTax);
  yearlyTotals.after.companyIns = ac(sumAfter.companyIns);
  yearlyTotals.after.retirement = ac(sumAfter.retirement);
  yearlyTotals.diff.nonTax = ac(diffNonTax);
  yearlyTotals.diff.companyIns = ac(diffCompanyIns);
  yearlyTotals.diff.retirement = ac(diffRetirement);
  yearlyTotals.saving = ac(totalSaving);
  yearlyTotals.avgSaving = monthCount > 0 ? ac(Math.round(totalSaving / monthCount)) : "0";
};

const generatePdf = async () => {
  isGeneratingPdf.value = true;
  try {
    const response = await axios.post("/api/getYearlyBeforeAfterPdf", {
      monthlyData: monthlySummary.value,
      yearlyTotals: {
        totalPay: yearlyTotals.totalPay,
        before: yearlyTotals.before,
        after: yearlyTotals.after,
        diff: yearlyTotals.diff,
        saving: yearlyTotals.saving,
        avgSaving: yearlyTotals.avgSaving
      },
      sisulName: store.state.AdminSisulName,
      year: selectedYear.value
    });

    const pdfBase64 = response.data.pdf;
    const binaryString = window.atob(pdfBase64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    const blob = new Blob([bytes], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    const newWindow = window.open(url, "_blank");
    if (newWindow) {
      newWindow.focus();
    }
  } catch (error) {
    console.error("PDF 생성 실패:", error);
    store.commit("showSnackbar", { text: "PDF 생성 중 오류가 발생했습니다.", color: "error" });
  } finally {
    isGeneratingPdf.value = false;
  }
};

__expose({ openDialog });

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dialog).value = $event)),
    "max-width": "1600px",
    class: "fontNotoSans400",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_v_icon, {
              class: "help-icon",
              color: showHelp.value ? '#1565c0' : '#888',
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showHelp.value = !showHelp.value)),
              title: "도움말 보기"
            }, {
              default: _withCtx(() => [
                _createTextVNode("mdi-help-circle-outline")
              ]),
              _: 1
            }, 8, ["color"])
          ]),
          _createVNode(_component_v_icon, {
            class: "close-btn",
            color: "#333",
            onClick: closeDialog
          }, {
            default: _withCtx(() => [
              _createTextVNode("mdi-close")
            ]),
            _: 1
          })
        ]),
        (showHelp.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_v_icon, {
                  size: "18",
                  color: "#666",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showHelp.value = false)),
                  class: "help-close"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-close")
                  ]),
                  _: 1
                })
              ]),
              _hoisted_8
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedYear).value = $event)),
                class: "year-select",
                onChange: fetchYearlyData
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableYears.value, (year) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: year,
                    value: year
                  }, _toDisplayString(year) + "년", 9, _hoisted_13))
                }), 128))
              ], 544), [
                [_vModelSelect, selectedYear.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("span", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, "임금대장: " + _toDisplayString(dataSourceCount.value.ledger) + "개월", 1),
                _createElementVNode("span", _hoisted_18, "엑셀업로드: " + _toDisplayString(dataSourceCount.value.excel) + "개월", 1),
                _createElementVNode("span", _hoisted_19, "데이터없음: " + _toDisplayString(dataSourceCount.value.none) + "개월", 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_v_btn, {
            class: "btnColorDark",
            onClick: generatePdf,
            disabled: !hasAnyData.value,
            loading: isGeneratingPdf.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(" PDF 생성 ")
            ]),
            _: 1
          }, 8, ["disabled", "loading"])
        ]),
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_v_progress_circular, {
                  indeterminate: "",
                  color: "primary"
                }),
                _hoisted_23
              ])
            ]))
          : (hasAnyData.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createVNode(_component_v_tabs, {
                  modelValue: activeTab.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((activeTab).value = $event)),
                  color: "primary"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_tab, { value: "monthly" }, {
                      default: _withCtx(() => [
                        _createTextVNode("월별 상세")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_tab, { value: "summary" }, {
                      default: _withCtx(() => [
                        _createTextVNode("연간 요약")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_v_window, {
                  modelValue: activeTab.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((activeTab).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_window_item, { value: "monthly" }, {
                      default: _withCtx(() => [
                        _hoisted_25,
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("table", _hoisted_27, [
                            _hoisted_28,
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(monthlySummary.value, (monthData) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: monthData.month,
                                  class: _normalizeClass({ 'no-data-row': !monthData.hasData })
                                }, [
                                  _createElementVNode("td", _hoisted_29, _toDisplayString(formatMonth(monthData.month)), 1),
                                  _createElementVNode("td", _hoisted_30, [
                                    (monthData.dataSource === 'ledger')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_31, "임금대장"))
                                      : (monthData.dataSource === 'excel')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_32, "엑셀업로드"))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_33, "-"))
                                  ]),
                                  _createElementVNode("td", _hoisted_34, _toDisplayString(monthData.hasData ? monthData.employeeCount + '명' : '-'), 1),
                                  _createElementVNode("td", _hoisted_35, _toDisplayString(monthData.hasData ? monthData.totalPay : '-'), 1),
                                  _createElementVNode("td", _hoisted_36, _toDisplayString(monthData.hasData ? monthData.before.nonTax : '-'), 1),
                                  _createElementVNode("td", _hoisted_37, _toDisplayString(monthData.hasData ? monthData.before.companyIns : '-'), 1),
                                  _createElementVNode("td", _hoisted_38, _toDisplayString(monthData.hasData ? monthData.before.retirement : '-'), 1),
                                  _createElementVNode("td", _hoisted_39, _toDisplayString(monthData.hasData ? monthData.after.nonTax : '-'), 1),
                                  _createElementVNode("td", _hoisted_40, _toDisplayString(monthData.hasData ? monthData.after.companyIns : '-'), 1),
                                  _createElementVNode("td", _hoisted_41, _toDisplayString(monthData.hasData ? monthData.after.retirement : '-'), 1),
                                  _createElementVNode("td", {
                                    class: _normalizeClass(["diff-cell text-right", getDiffClass(monthData.diff?.companyIns, true)])
                                  }, _toDisplayString(monthData.hasData ? monthData.diff.companyIns : '-'), 3),
                                  _createElementVNode("td", {
                                    class: _normalizeClass(["diff-cell text-right", getDiffClass(monthData.diff?.retirement, true)])
                                  }, _toDisplayString(monthData.hasData ? monthData.diff.retirement : '-'), 3),
                                  _createElementVNode("td", {
                                    class: _normalizeClass(["saving-cell text-right font-bold", getDiffClass(monthData.saving, true)])
                                  }, _toDisplayString(monthData.hasData ? monthData.saving : '-'), 3)
                                ], 2))
                              }), 128))
                            ]),
                            _createElementVNode("tfoot", null, [
                              _createElementVNode("tr", _hoisted_42, [
                                _hoisted_43,
                                _createElementVNode("td", _hoisted_44, _toDisplayString(dataSourceCount.value.ledger + dataSourceCount.value.excel) + "개월", 1),
                                _hoisted_45,
                                _createElementVNode("td", _hoisted_46, _toDisplayString(yearlyTotals.totalPay), 1),
                                _createElementVNode("td", _hoisted_47, _toDisplayString(yearlyTotals.before.nonTax), 1),
                                _createElementVNode("td", _hoisted_48, _toDisplayString(yearlyTotals.before.companyIns), 1),
                                _createElementVNode("td", _hoisted_49, _toDisplayString(yearlyTotals.before.retirement), 1),
                                _createElementVNode("td", _hoisted_50, _toDisplayString(yearlyTotals.after.nonTax), 1),
                                _createElementVNode("td", _hoisted_51, _toDisplayString(yearlyTotals.after.companyIns), 1),
                                _createElementVNode("td", _hoisted_52, _toDisplayString(yearlyTotals.after.retirement), 1),
                                _createElementVNode("td", {
                                  class: _normalizeClass(["diff-cell text-right font-bold", getDiffClass(yearlyTotals.diff.companyIns, true)])
                                }, _toDisplayString(yearlyTotals.diff.companyIns), 3),
                                _createElementVNode("td", {
                                  class: _normalizeClass(["diff-cell text-right font-bold", getDiffClass(yearlyTotals.diff.retirement, true)])
                                }, _toDisplayString(yearlyTotals.diff.retirement), 3),
                                _createElementVNode("td", {
                                  class: _normalizeClass(["saving-cell text-right font-bold", getDiffClass(yearlyTotals.saving, true)])
                                }, _toDisplayString(yearlyTotals.saving), 3)
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_window_item, { value: "summary" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_53, [
                          _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("div", _hoisted_55, [
                              _hoisted_56,
                              _createElementVNode("div", _hoisted_57, [
                                _hoisted_58,
                                _createElementVNode("span", _hoisted_59, _toDisplayString(yearlyTotals.totalPay), 1)
                              ]),
                              _createElementVNode("div", _hoisted_60, [
                                _hoisted_61,
                                _createElementVNode("span", _hoisted_62, _toDisplayString(yearlyTotals.before.nonTax), 1)
                              ]),
                              _hoisted_63,
                              _createElementVNode("div", _hoisted_64, [
                                _hoisted_65,
                                _createElementVNode("span", _hoisted_66, _toDisplayString(yearlyTotals.before.companyIns), 1)
                              ]),
                              _createElementVNode("div", _hoisted_67, [
                                _hoisted_68,
                                _createElementVNode("span", _hoisted_69, _toDisplayString(yearlyTotals.before.retirement), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_70, [
                              _hoisted_71,
                              _createElementVNode("div", _hoisted_72, [
                                _hoisted_73,
                                _createElementVNode("span", _hoisted_74, _toDisplayString(yearlyTotals.totalPay), 1)
                              ]),
                              _createElementVNode("div", _hoisted_75, [
                                _hoisted_76,
                                _createElementVNode("span", _hoisted_77, _toDisplayString(yearlyTotals.after.nonTax), 1)
                              ]),
                              _hoisted_78,
                              _createElementVNode("div", _hoisted_79, [
                                _hoisted_80,
                                _createElementVNode("span", _hoisted_81, _toDisplayString(yearlyTotals.after.companyIns), 1)
                              ]),
                              _createElementVNode("div", _hoisted_82, [
                                _hoisted_83,
                                _createElementVNode("span", _hoisted_84, _toDisplayString(yearlyTotals.after.retirement), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_85, [
                              _hoisted_86,
                              _createElementVNode("div", _hoisted_87, [
                                _hoisted_88,
                                _createElementVNode("span", _hoisted_89, _toDisplayString(dataSourceCount.value.ledger + dataSourceCount.value.excel) + "개월", 1)
                              ]),
                              _hoisted_90,
                              _createElementVNode("div", _hoisted_91, [
                                _hoisted_92,
                                _createElementVNode("span", {
                                  class: _normalizeClass(["value", getDiffClass(yearlyTotals.diff.companyIns, true)])
                                }, _toDisplayString(yearlyTotals.diff.companyIns), 3)
                              ]),
                              _createElementVNode("div", _hoisted_93, [
                                _hoisted_94,
                                _createElementVNode("span", {
                                  class: _normalizeClass(["value", getDiffClass(yearlyTotals.diff.retirement, true)])
                                }, _toDisplayString(yearlyTotals.diff.retirement), 3)
                              ]),
                              _hoisted_95,
                              _createElementVNode("div", _hoisted_96, [
                                _hoisted_97,
                                _createElementVNode("span", {
                                  class: _normalizeClass(["value large", getDiffClass(yearlyTotals.saving, true)])
                                }, _toDisplayString(yearlyTotals.saving), 3)
                              ]),
                              _createElementVNode("div", _hoisted_98, [
                                _hoisted_99,
                                _createElementVNode("span", {
                                  class: _normalizeClass(["value", getDiffClass(yearlyTotals.saving, true)])
                                }, _toDisplayString(yearlyTotals.avgSaving), 3)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_100, [
                            _hoisted_101,
                            _createElementVNode("div", _hoisted_102, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(monthlySummary.value, (monthData) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: monthData.month,
                                  class: "chart-bar-wrapper"
                                }, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["chart-bar", { positive: monthData.savingRaw < 0, negative: monthData.savingRaw > 0, 'no-data': !monthData.hasData }]),
                                    style: _normalizeStyle({ height: getBarHeight(monthData.savingRaw) + 'px' })
                                  }, null, 6),
                                  _createElementVNode("span", _hoisted_103, _toDisplayString(monthData.month.split('-')[1]) + "월", 1),
                                  (monthData.hasData)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_104, _toDisplayString(monthData.saving), 1))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_105, [
                _createElementVNode("p", null, _toDisplayString(selectedYear.value) + "년 데이터가 없습니다.", 1)
              ])),
        _createElementVNode("div", _hoisted_106, [
          _createVNode(_component_v_btn, {
            class: "cancelRegistBtn",
            onClick: closeDialog
          }, {
            default: _withCtx(() => [
              _createTextVNode("닫기")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})